if (!customElements.get('popbrush-design-choice')) {
  customElements.define('popbrush-design-choice', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      if (!this.isConnected || this.initialized) return;
      this.initialized = true;
      this.customFields = this.querySelector('[data-custom-fields]');
      this.fileInput = this.querySelector('input[type="file"]');
      this.errorText = this.querySelector('[data-file-error]');
      this.addEventListener('change', () => this.update());
      this.update();
    }

    update() {
      const custom = this.querySelector('[data-design="custom"]').checked;
      const uploadNow = custom && this.querySelector('[data-delivery="now"]').checked;
      this.customFields.hidden = !custom;
      this.customFields.querySelectorAll('input, textarea').forEach(input => {
        input.disabled = !custom;
      });
      this.querySelector('[data-upload-fields]').hidden = !uploadNow;
      this.querySelector('[data-send-later-help]').hidden = !custom || uploadNow;
      this.fileInput.disabled = !uploadNow;
      this.fileInput.required = uploadNow;
      if (!uploadNow) this.fileInput.value = '';

      let error = '';
      const file = this.fileInput.files[0];
      if (uploadNow && file) {
        if (!/\.(jpe?g|png|webp|gif|heic|heif|pdf)$/i.test(file.name)) {
          error = this.dataset.fileTypeError;
        } else if (file.size > 10 * 1024 * 1024) {
          error = this.dataset.fileSizeError;
        }
      }
      this.fileInput.setCustomValidity(error);
      this.fileInput.setAttribute('aria-invalid', error ? 'true' : 'false');
      this.errorText.textContent = error;
      this.errorText.hidden = !error;
    }
  });
}
